export interface AmortizationRow {
    date: string;
    capital: number;
}

export interface AmortizationRowComputed extends AmortizationRow {
    interest: number;
}

export interface ParametricosDataForm {
    creditSurfaceHa: number;
    investmentConceptCt: string;
    investmentConceptRefa: string;
    program: string;
    fundingSource: string;
    promoter: string;
    contract: {
        classification: string;
        contractNumber: string;
        amount: number;
        openingDate: string;
        maturityDateOverride: string;
    };
    assetValue: number;
    financingAmountOverride: number | null;
    amortizationRows: Array<AmortizationRow>;
    liabilities: {
        shortTerm: number;
        longTerm: number;
    };
    longTermAmortizations: [number, number, number, number, number];
    assets: {
        movable: number;
        immovable: number;
    };
}

/** Filas editables por año (Año 1..9); la columna "Actual" no aplica a estas filas. */
export interface ParametricosProjectionForm {
    servicesIncome: Array<number>;
    supportIncome: Array<number>;
    rentCost: Array<number>;
    servicesCost: Array<number>;
    workingCapitalInterest: Array<number>;
    currentYearCapital: number;
    otherIncome: Array<number>;
    otherExpenses: Array<number>;
    notes: {
        a: string;
        b: string;
        c: string;
        d: string;
        e: string;
    };
}

export const PROJECTION_YEARS_COUNT = 9;

export const emptyYearArray = (): Array<number> => Array.from({ length: PROJECTION_YEARS_COUNT }, () => 0);

export const defaultDataForm: ParametricosDataForm = {
    creditSurfaceHa: 0,
    investmentConceptCt: "",
    investmentConceptRefa: "",
    program: "",
    fundingSource: "",
    promoter: "",
    contract: {
        classification: "",
        contractNumber: "",
        amount: 0,
        openingDate: "",
        maturityDateOverride: "",
    },
    assetValue: 0,
    financingAmountOverride: null,
    amortizationRows: [],
    liabilities: { shortTerm: 0, longTerm: 0 },
    longTermAmortizations: [0, 0, 0, 0, 0],
    assets: { movable: 0, immovable: 0 },
};

export const defaultProjectionForm: ParametricosProjectionForm = {
    servicesIncome: emptyYearArray(),
    supportIncome: emptyYearArray(),
    rentCost: emptyYearArray(),
    servicesCost: emptyYearArray(),
    workingCapitalInterest: emptyYearArray(),
    currentYearCapital: 0,
    otherIncome: emptyYearArray(),
    otherExpenses: emptyYearArray(),
    notes: { a: "", b: "", c: "", d: "", e: "" },
};

/** Bajo `extra_conditions.parametric` de la `Condition` activa. */
export interface ParametricosExtraConditions {
    data?: Partial<ParametricosDataForm>;
    projection?: Partial<ParametricosProjectionForm>;
}
